import(/* webpackMode: "eager" */ "D:\\Work\\Completed Projects\\Next\\Bohesto\\Bohesto\\Bohesto\\app\\layout.js");
